import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const MARK_EMDR_DOCUMENT_AS_SEEN = "MARK_EMDR_DOCUMENT_AS_SEEN";

export const service = async (data) => {
  const options: object = {
    url: "/api/EMDR/MarkDocumentAsSeen",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(MARK_EMDR_DOCUMENT_AS_SEEN, service, mock);
